import { render, staticRenderFns } from "./ToothTreatmentService.vue?vue&type=template&id=7e79270c&scoped=true&"
import script from "./ToothTreatmentService.vue?vue&type=script&lang=js&"
export * from "./ToothTreatmentService.vue?vue&type=script&lang=js&"
import style0 from "./ToothTreatmentService.vue?vue&type=style&index=0&id=7e79270c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e79270c",
  null
  
)

export default component.exports